<div class="row">
  <div class="col-120 col-sm-40">
    <card name="Pipe чисел и дат">
      <div card content>
        <p class="font-weight-bold">Numeral</p>
        <table class="w-100 mb-5">
          <tr>
            <td>currency$</td>
            <td>{{ 12999 | numeral }}</td>
          </tr>
          <tr>
            <td>currency</td>
            <td>{{ 12999 | numeral: 'currency' }}</td>
          </tr>
          <tr>
            <td>number</td>
            <td>{{ 12999 | numeral: 'number' }}</td>
          </tr>
          <tr>
            <td>aroundDecimal</td>
            <td>{{ 12999 | numeral: 'aroundDecimal' }}</td>
          </tr>
          <tr>
            <td>percentages</td>
            <td>{{ 0.95 | numeral: 'percentages' }}</td>
          </tr>
          <tr>
            <td>thousand</td>
            <td>{{ 12999 | numeral: 'thousand' }}</td>
          </tr>
          <tr>
            <td>short</td>
            <td>{{ 12999 | numeral: 'short' }}</td>
          </tr>
          <tr>
            <td>int</td>
            <td>{{ 12.999 | numeral: 'int' }}</td>
          </tr>
        </table>

        <p class="font-weight-bold">Moment</p>
        <table class="w-100">
          <tr>
            <td>dmy</td>
            <td>{{ date | moment: 'dmy' }}</td>
          </tr>
          <tr>
            <td>dmyhm</td>
            <td>{{ date | moment: 'dmyhm' }}</td>
          </tr>
          <tr>
            <td>dmywhm</td>
            <td>{{ date | moment: 'dmywhm' }}</td>
          </tr>
          <tr>
            <td>dmyhms</td>
            <td>{{ date | moment: 'dmyhms' }}</td>
          </tr>
          <tr>
            <td>hms</td>
            <td>{{ date | moment: 'hms' }}</td>
          </tr>
        </table>
      </div>
    </card>
  </div>
  <div class="col-120 col-sm-40">

  </div>
</div>
